var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.569 11.036H7.534a.992.992 0 00-.996.996c0 .553.443.996.996.996H18.57l-2.458 2.48a.989.989 0 000 1.416.989.989 0 001.417 0l4.184-4.184c.177-.177.288-.442.288-.708 0-.266-.11-.51-.288-.708l-4.206-4.162a.969.969 0 00-.708-.288.888.888 0 00-.687.288.989.989 0 000 1.417l2.458 2.457z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.996 21.064h10.161a.992.992 0 00.996-.996v-3.874a.992.992 0 00-.996-.996.992.992 0 00-.996.996v2.878H3.992V4.992h8.169V7.87c0 .554.443.996.996.996a.992.992 0 00.996-.996V3.996A.992.992 0 0013.157 3H2.997A.992.992 0 002 3.996v16.05c0 .553.443 1.018.996 1.018z",
    fill: "#818181"
  })));
}

export default SvgLogout;